import CryptoJS from 'crypto-js';
import { getWebCryptoSubtle, sha256Hex } from '../../utils/gameCrypto';

export { sha256Hex };

const MULNYANG_INTERNAL_KEY = process.env.REACT_APP_GAME_INTERNAL_KEY ?? 'q7mK2v9xP4sR8nT1cL6wZ3aF0yH5dJ';

const base64ToBytes = (base64Text) => {
  const binary = window.atob(base64Text);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
};

const decryptWithSubtle = async ({ roundToken, encryptedPayload, subtle }) => {
  const combined = base64ToBytes(encryptedPayload.trim());
  if (combined.length <= 16) throw new Error('INVALID_PAYLOAD');

  const iv = combined.slice(0, 16);
  const cipherBytes = combined.slice(16);
  const keyMaterial = new TextEncoder().encode(`${MULNYANG_INTERNAL_KEY}${roundToken}`);
  const keyDigest = await subtle.digest('SHA-256', keyMaterial);
  const cryptoKey = await subtle.importKey('raw', keyDigest, { name: 'AES-CBC' }, false, ['decrypt']);
  const plainBuffer = await subtle.decrypt({ name: 'AES-CBC', iv }, cryptoKey, cipherBytes);
  return new TextDecoder().decode(plainBuffer);
};

const decryptWithCryptoJs = ({ roundToken, encryptedPayload }) => {
  const combined = CryptoJS.enc.Base64.parse(encryptedPayload.trim());
  if (combined.sigBytes <= 16) throw new Error('INVALID_PAYLOAD');

  const iv = CryptoJS.lib.WordArray.create(combined.words.slice(0, 4), 16);
  const ciphertext = CryptoJS.lib.WordArray.create(
    combined.words.slice(4),
    combined.sigBytes - 16,
  );
  const key = CryptoJS.SHA256(`${MULNYANG_INTERNAL_KEY}${roundToken}`);
  const decrypted = CryptoJS.AES.decrypt({ ciphertext }, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  const plainText = decrypted.toString(CryptoJS.enc.Utf8);
  if (!plainText) throw new Error('DECRYPT_FAILED');
  return plainText;
};

export const decryptMulnyangEncryptedPayload = async ({ roundToken, encryptedPayload }) => {
  if (!roundToken || !encryptedPayload) throw new Error('PAYLOAD_REQUIRED');

  const subtle = getWebCryptoSubtle();
  if (subtle) {
    return decryptWithSubtle({ roundToken, encryptedPayload, subtle });
  }
  return decryptWithCryptoJs({ roundToken, encryptedPayload });
};

export const parseMulnyangAnswerPlaintext = (plainText) => {
  const [token, rowText, colText] = String(plainText ?? '').split('||');
  if (!token || rowText == null || colText == null) throw new Error('INVALID_PLAINTEXT_FORMAT');
  const answerRow = Number(rowText);
  const answerCol = Number(colText);
  if (!Number.isInteger(answerRow) || !Number.isInteger(answerCol)) {
    throw new Error('INVALID_PLAINTEXT_COORD');
  }
  return { token, answerRow, answerCol };
};
